<button
  [matMenuTriggerFor]="profileMenu"
  #profileMenuTrigger="matMenuTrigger"
  class="profile-button"
  aria-label="Toggle profile popover"
>
  <mat-icon class="profile-picture">account_circle</mat-icon>
</button>
<mat-menu #profileMenu="matMenu">
  <!--
    mat-menu binds `closed.emit('click')` on its own panel, so it closes on any
    click that reaches it. Only the presentational blocks stop propagation, to
    survive a stray click on the header or the email; the "X" closes explicitly
    instead. The actions are deliberately left outside that guard — picking an
    option has to dismiss the menu.
  -->
  <!-- eslint-disable-next-line @angular-eslint/template/click-events-have-key-events, @angular-eslint/template/interactive-supports-focus -->
  <div (click)="$event.stopPropagation()">
    <div class="profile-header">
      <h3>{{'layout.top.myAccount' | translate}}</h3>
      <button
        class="mat-icon-button"
        matIconButton
        (click)="profileMenuTrigger.closeMenu()"
      >X</button>
    </div>
    <div class="separator"></div>
    <div class="profile-info">
      <mat-icon class="profile-picture">account_circle</mat-icon>
      <div class="profile-details">
        <div>
          <span class="profile-name">{{ userName() }}</span>
        </div>
        <div class="profile-email-container">
          <mat-icon class="mail-icon">mail</mat-icon>
          <span class="profile-email" matTooltip="{{ userEmail() }}">{{ userEmailToShow() }}</span>
        </div>
      </div>
    </div>
  </div>
  <div class="separator"></div>
  <div class="profile-actions">
    <a mat-menu-item href=""><mat-icon>key</mat-icon>{{'layout.top.changePassword' | translate}}</a>
    <button mat-menu-item (click)="logoutRequested.emit()">
      <mat-icon>logout</mat-icon>{{'layout.top.logout' | translate}}
    </button>
  </div>
</mat-menu>
